/**
 * @author      patrick@zumper.com (Patrick Giddings)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { combineReducers } from '@reduxjs/toolkit'
import { RENT_RESEARCH_DETAIL_SLICE_NAME } from '../constants'
import { rentResearchDetailDataSlice } from './rentResearchDetailDataSlice'
import { rentResearchDetailMetaSlice } from './rentResearchDetailMetaSlice'

export const rentResearchDetailSlice = {
  name: `${RENT_RESEARCH_DETAIL_SLICE_NAME}/detail`,
  reducer: combineReducers({
    data: rentResearchDetailDataSlice.reducer,
    meta: rentResearchDetailMetaSlice.reducer,
  }),
  actions: {
    ...rentResearchDetailDataSlice.actions,
    ...rentResearchDetailMetaSlice.actions,
  },
}

export const {
  errorFetchingRentResearchDetailRentalData,
  doneFetchingRentResearchDetailRentalData,
  setRentResearchDetailActiveBedType,
  setRentResearchDetailActivePropertyType,
  receiveRentResearchDetailCostOfLivingCategories,
  receiveRentResearchDetailDiscover,
  receiveRentResearchDetailLinkpacks,
  receiveRentResearchDetailLocationData,
  receiveRentResearchDetailRentalData,
  receiveRentResearchDetailRenterOccupiedPercentage,
  startFetchingRentResearchDetailRentalData,
} = rentResearchDetailSlice.actions
